import { createAction } from 'redux-actions'

export const logout = createAction('USER_LOGGED_OUT')
export const login = createAction('USER_LOGIN_REQUESTED')
export const getUser = createAction('GET_USER_REQUESTED')



// WEBPACK FOOTER //
// ./src/actions/user.js